import React from 'react';
import BotText from '../Messages/Bot.Text.Message';
import UserText from '../Messages/User.Text.Message';
import Image from '../Messages/Image.Message';
import HistorySeparator from '../Messages/Components/HistorySeparator';
import Floorplan from '../Messages/Floorplan.Message';
import { useStateSelector } from '../../../global/utils/stateUtils';

const messageTypes = {
  user: {
    text: UserText,
    image: Image,
    floorplan: Floorplan,
  },
  bot: {
    text: BotText,
  },
};

function List() {
  const {
    chat: { messages, typing },
  } = useStateSelector();

  const avatar = () => {
      if (messages.length == 0) {
          return true;
      }

      return messages[messages.length -1].author !== 'bot';
  }

  return (
    <>
      {messages.map((message, key) => {
        if (message.type === 'history-separator') {
          return <HistorySeparator key="history-separator" />;
        }
        const MessageType = messageTypes[message.author][message.type];
        return (
          <MessageType
            className="MessageType"
            data={message}
            key={`messages-${key}`}
          />
        );
      })}
      {typing && <BotText typing avatar={avatar}/>}
    </>
  );
}

export default List;
